import { Search } from "@mui/icons-material";
import { Button, Grid, Paper, useTheme } from "@mui/material";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { connect, ConnectedProps } from "react-redux";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { thunkInteractionSearch } from "../../store/actions/InteractionActions";
import { IStore } from "../../store/IStore";
import ImsPaperHead from "../atoms/ImsPaperHead";
import { nameof } from "../atoms/Utils";
import { FormSelect } from "../atoms/FormSelect";
import { ReceiptApprovalStatus } from "../../store/models/receipt/ReceiptApprovalStatus";

export interface ReceiptSearchCondition {
  status?: string[];
}

interface ReceiptSearchProps {
  setSearchCondition: React.Dispatch<React.SetStateAction<ReceiptSearchCondition>>;
}

const ReceiptSearch = (props: ReceiptSearchProps & ThunkProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { setSearchCondition } = props;

  const onSubmit = (receiptSearchCondition: ReceiptSearchCondition) => {
    const flattenedStatusKeys: string[] = [];

    if (receiptSearchCondition.status && receiptSearchCondition.status.length > 0) {
      receiptSearchCondition.status.forEach((keyArray) => {
        if (Array.isArray(keyArray)) {
          keyArray.forEach((key) => {
            if (!flattenedStatusKeys.includes(key)) {
              flattenedStatusKeys.push(key);
            }
          });
        }
      });
    }

    setSearchCondition({
      status: flattenedStatusKeys,
    });
  };

  const receiptTypeOption = Object.entries(receiptSearchOptions).map(([key, values]) => ({
    label: t(`receiptSearchStatus.${key}`),
    value: values,
  }));

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        status: [],
      }}
      render={({ handleSubmit, submitting }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Paper
              style={{
                padding: theme.spacing(3, 3, 6, 3),
                margin: theme.spacing(6, 0, 3, 0),
              }}
            >
              <ImsPaperHead text={t("receiptOverview.receiptSearch.title")} />
              <Grid container spacing={4}>
                <Grid container spacing={2} item>
                  <Grid item xs={12} sm={6} lg={3}>
                    <FormSelect
                      name={nameof<ReceiptSearchCondition>("status")}
                      label={t("receiptOverview.receiptSearch.status")}
                      multiple={true}
                      fullWidth
                      options={receiptTypeOption}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            <Grid container style={{ marginBottom: theme.spacing(3) }} justifyContent="flex-end">
              <Button color="primary" type="submit" variant="contained" disabled={submitting}>
                <Search />
                {t("receiptOverview.receiptSearch.buttonSearch")}
              </Button>
            </Grid>
          </form>
        );
      }}
    />
  );
};

const receiptSearchOptions = {
  new: [ReceiptApprovalStatus.UPLOADING, ReceiptApprovalStatus.UPLOADED],
  rejected: [ReceiptApprovalStatus.UPLOAD_FAILED, ReceiptApprovalStatus.REJECTED, ReceiptApprovalStatus.EXTRACT_FAILED],
  waitingForApproval: [ReceiptApprovalStatus.WAITING_FOR_APPROVAL],
  accepted: [ReceiptApprovalStatus.APPROVED, ReceiptApprovalStatus.REQUESTING_CREATE_INTERACTION],
  completed: [ReceiptApprovalStatus.COMPLETED],
};

const mapStateToProps = (state: IStore) => ({});

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators({ thunkInteractionSearch }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);
type ThunkProps = ConnectedProps<typeof connector>;
export default connector(ReceiptSearch);
